import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Textarea } from "../components/ui/textarea";
import { Label } from "../components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "../components/ui/dialog";
import { Plus, Trash2, Edit3 } from "lucide-react";
import { toast } from "sonner";

const KIND_LABEL = { contract: "Contrato", collab_term: "Termo de Colaboração Técnica" };
const KIND_COLOR = { contract: "#C07C88", collab_term: "#D4AF37" };

export default function Templates() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ name: "", body: "", kind: "contract" });
  const [open, setOpen] = useState(false);
  const load = () => api.get("/templates").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    if (editing) await api.put(`/templates/${editing}`, form);
    else await api.post("/templates", form);
    toast.success("Salvo");
    setOpen(false); setEditing(null); setForm({ name: "", body: "", kind: "contract" }); load();
  };
  const startEdit = (t) => { setEditing(t.template_id); setForm({ name: t.name, body: t.body, kind: t.kind || "contract" }); setOpen(true); };
  const remove = async (id) => { await api.delete(`/templates/${id}`); load(); };

  return (
    <div className="p-10 max-w-[1200px]">
      <div className="flex items-end justify-between mb-8">
        <div>
          <p className="overline">Documentos Jurídicos</p>
          <h1 className="font-heading text-4xl mt-2">Modelos</h1>
          <p className="text-xs text-muted-foreground mt-2">
            <b>Contrato</b>: {`{{cliente_nome}} {{empresa_nome}} {{escopo}} {{valor_total}} {{prazo}} {{foro}}`}<br />
            <b>Termo de Colaboração</b>: {`{{contratante_razao_social}} {{contratante_apelido}} {{contratante_endereco}} {{contratante_cnpj}} {{contratante_representante}} {{titulo_treinamento}} {{local_treinamento}} {{data_inicio}} {{data_fim}} {{qtd_participantes}} {{cidade_assinatura}} {{data_assinatura}}`}
          </p>
        </div>
        <Dialog open={open} onOpenChange={(v) => { setOpen(v); if (!v) { setEditing(null); setForm({ name: "", body: "", kind: "contract" }); } }}>
          <DialogTrigger asChild><Button className="bg-[#C07C88] hover:bg-[#A86571]" data-testid="new-template-btn"><Plus size={16} className="mr-1" /> Novo modelo</Button></DialogTrigger>
          <DialogContent className="max-w-3xl">
            <DialogHeader><DialogTitle>{editing ? "Editar" : "Novo"} modelo</DialogTitle></DialogHeader>
            <div className="space-y-3">
              <div className="grid grid-cols-3 gap-3">
                <div className="col-span-2"><Label>Nome</Label><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="template-name" /></div>
                <div>
                  <Label>Tipo</Label>
                  <Select value={form.kind} onValueChange={(v) => setForm({ ...form, kind: v })}>
                    <SelectTrigger data-testid="template-kind"><SelectValue /></SelectTrigger>
                    <SelectContent>
                      <SelectItem value="contract">Contrato</SelectItem>
                      <SelectItem value="collab_term">Termo de Colaboração Técnica</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
              </div>
              <div><Label>Corpo (use variáveis {`{{...}}`})</Label><Textarea rows={16} value={form.body} onChange={(e) => setForm({ ...form, body: e.target.value })} className="font-mono text-xs" data-testid="template-body" /></div>
            </div>
            <DialogFooter><Button className="bg-[#C07C88] hover:bg-[#A86571]" onClick={save} data-testid="save-template-btn">Salvar</Button></DialogFooter>
          </DialogContent>
        </Dialog>
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        {items.map((t) => (
          <Card key={t.template_id} className="p-5 border-border shadow-none" data-testid={`template-${t.template_id}`}>
            <div className="flex items-start justify-between">
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="text-[9px] px-2 py-0.5 rounded-full uppercase tracking-wider" style={{ background: `${KIND_COLOR[t.kind || "contract"]}15`, color: KIND_COLOR[t.kind || "contract"] }}>{KIND_LABEL[t.kind || "contract"]}</span>
                  {t.is_default && <span className="text-[9px] px-2 py-0.5 rounded-full bg-[#FDF9EE] text-[#D4AF37]">PADRÃO</span>}
                </div>
                <p className="font-medium mt-2">{t.name}</p>
                <p className="text-xs text-muted-foreground mt-2 line-clamp-3">{t.body}</p>
              </div>
              <div className="flex gap-1 shrink-0 ml-2">
                <button onClick={() => startEdit(t)} className="p-1.5 hover:text-[#C07C88]" data-testid={`edit-template-${t.template_id}`}><Edit3 size={14} /></button>
                {!t.is_default && <button onClick={() => remove(t.template_id)} className="p-1.5 hover:text-red-500"><Trash2 size={14} /></button>}
              </div>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
